import { render, staticRenderFns } from "./file-uploader.vue?vue&type=template&id=45c3b4a6&scoped=true&"
import script from "./file-uploader.vue?vue&type=script&lang=ts&"
export * from "./file-uploader.vue?vue&type=script&lang=ts&"
import style0 from "./file-uploader.vue?vue&type=style&index=0&id=45c3b4a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c3b4a6",
  null
  
)

export default component.exports